import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "app-bottom"
};
const _hoisted_2 = {
  class: "bottom-text"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("div", null, " Copyright © 2020-2025 Amalia All Rights Reserved. ", -1)), _cache[2] || (_cache[2] = _createElementVNode("div", null, [_createElementVNode("a", {
    href: "mailto: amaliacs001@gmail.com"
  }, "Contact us: amaliacs001@gmail.com")], -1)), $data.show_secur ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
    src: $data.secure_img,
    style: {
      "width": "20px",
      "height": "20px",
      "margin-right": "5px"
    }
  }, null, 8, _hoisted_4), _cache[0] || (_cache[0] = _createElementVNode("a", {
    href: "https://beian.mps.gov.cn/#/query/webSearch?code=42018502007595",
    rel: "noreferrer",
    target: "_blank"
  }, "鄂公网安备42018502007595", -1))])) : _createCommentVNode("", true)])]);
}